/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InventoryUser } from '../../models/inventory-user';

export interface AddInventoryUser$Params {
  id: string;
  userId: string;
  roleId: number;
}

export function addInventoryUser(http: HttpClient, rootUrl: string, params: AddInventoryUser$Params, context?: HttpContext): Observable<StrictHttpResponse<InventoryUser>> {
  const rb = new RequestBuilder(rootUrl, addInventoryUser.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('userId', params.userId, {});
    rb.query('roleId', params.roleId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InventoryUser>;
    })
  );
}

addInventoryUser.PATH = '/admin/inventories/{id}/users';
